import React, { useState, useEffect, useRef } from 'react'
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom'
import { Layout, Menu, Spin } from 'antd'
// import { FullscreenOutlined } from '@ant-design/icons'
import Welcome from '@/pages/welcome/Welcome'
import { useSelector } from 'react-redux'
import Header from '@/pages/layout/header/Header'
import { withPermission, isVisibleItem, isVisibleItemStrict, hasVisibleChildren } from '@/annotations/nike-react'
import _ from 'lodash'
// import store from '@/redux'
import { routerConfigIn, routerConfigEx } from '@/router/router'
import { isExtranetHostname } from '@/utils/hostEnv'
import Page404 from '@/components/page404/page404'
import { clearAuthentication, getAuthenticationStatus, redirectURL } from '@/utils/authHelp'
import { formatMessage, languageObj } from '@/utils/common'
import { modalError } from '@/utils/modalUtils'
const { Content, Sider } = Layout
const defaultHeight = 60
const defaultSiderSize = 220
const routerConfig = isExtranetHostname() ? routerConfigEx : routerConfigIn
const generateRoute = (routerConfig = []) => {
  return _.flatten(
    routerConfig.map(config => {
      return _.concat(
        generateRoute(config.children),
        config.component ? (
          <Route
            key={config.key}
            path={config.key}
            render={withPermission(config.permission, config.permissionRule)(config.component)}
          />
        ) : (
          []
        )
      )
    })
  )
}

const MainLayout = props => {
  const spinLoading = useSelector(state => state.loadingStore.loading)
  const commonStore = useSelector(state => state.commonStore)
  let languageState = useSelector(state => state.commonStore.language)
  const history = useHistory()
  const initMenus = (list, resList) => {
    list.forEach((item, idx) => {
      if (languageState === 'zh_CN') {
        item.label = item.labelZh
      }
      if (languageState === 'en_US') {
        item.label = item.labelEn
      }
      item.title = item.label
      delete item.labelZh
      delete item.labelEn
      if (isVisibleItem(item)) {
        if (hasVisibleChildren(item)) {
          let flattenDeepChild = flattenDeep(item.children)
          // 开始-判断所有子菜单有没有权限，如果一个权限都没有，隐藏此菜单
          let isHidden = false
          for (let index = 0; index < flattenDeepChild.length; index++) {
            const flattenDeepChildItem = flattenDeepChild[index]
            if (isVisibleItemStrict(flattenDeepChildItem)) {
              isHidden = false
              break
            } else {
              isHidden = true
            }
          }
          item.hidden = isHidden
          // 结束
          resList[idx] = _.cloneDeep(item)
          resList[idx].children = []
          return initMenus(item.children, resList[idx].children)
        } else {
          if (item.component) {
            let noChildren = _.cloneDeep(item)
            delete noChildren.children
            delete noChildren.activeMenuKeys
            return (resList[idx] = noChildren)
          }
        }
      }
    })
    return resList
  }
  // 扁平化子菜单
  const flattenDeep = list => {
    let flattened = []
    ;(function flatten(list) {
      list.forEach(item => {
        if (item.children) {
          flatten(item.children)
        }
        flattened.push(item)
      })
    })(list)
    return flattened
  }

  const [openKeys, setOpenKeys] = useState([])
  const [menusList, setMenusList] = useState([])
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const menuLoaction = useLocation()
  useEffect(() => {
    setMenusList(initMenus(_.cloneDeep(routerConfig), []))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])
  // store.subscribe(() => {
  //   const state = store.getState()
  //   const language = state.commonStore.language
  //   if (language !== languageState) {
  //     languageState = state.commonStore.language
  //     setMenusList(initMenus(_.cloneDeep(routerConfig), []))
  //   }
  // })
  useEffect(() => {
    setMenusList(initMenus(_.cloneDeep(routerConfig), []))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const initOpenKeys = () => {
    let pathName = menuLoaction.pathname
    const getKeys = (list, resList) => {
      for (let item of list) {
        if (item.key === pathName) {
          return [...resList, item.key]
        } else if (isVisibleItem(item) && hasVisibleChildren(item)) {
          let tempResult = getKeys(item.children, [...resList, item.key])
          if (tempResult !== false) {
            return tempResult
          }
        }
      }
      return false
    }
    let resKeys = getKeys(_.cloneDeep(routerConfig), [])
    return resKeys
  }
  const searchUrlKey = menus => {
    let resKeys = initOpenKeys()
    setOpenKeys(resKeys)
  }
  useEffect(() => {
    searchUrlKey(_.cloneDeep(routerConfig))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location])
  const onOpenChange = openKeys => {
    setOpenKeys(openKeys)
  }
  const menuClick = ({ key, keyPath, domEvent }) => {
    history.push(key)
  }
  const containerRef = useRef(null)
  const tokenInvalidModalShown = useRef(false)
  const authStatus = getAuthenticationStatus()
  const getTokenInvalidContent = () => {
    const content = formatMessage(commonStore, 'languageObj.httpLocale.tokenInvalid')
    if (content) return content

    const currentLanguageObj = languageObj[languageState] || {}
    const httpLocale = currentLanguageObj.httpLocale || {}
    return httpLocale.tokenInvalid || 'The access token is invalid'
  }
  const handleTokenInvalid = () => {
    if (tokenInvalidModalShown.current) return
    tokenInvalidModalShown.current = true
    modalError(
      {
        content: getTokenInvalidContent()
      },
      () => {
        tokenInvalidModalShown.current = false
        clearAuthentication()
        window.location.href = redirectURL
      }
    )
  }
  useEffect(() => {
    if (authStatus.reason === 'expired' || authStatus.reason === 'invalid') {
      handleTokenInvalid()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus.reason])
  // const handleFullScreen = () => {
  //   const container = containerRef.current
  //   if (container.requestFullscreen) {
  //     container.requestFullscreen()
  //   } else if (container.webkitRequestFullscreen) {
  //     container.webkitRequestFullscreen()
  //   } else if (container.msRequestFullscreen) {
  //     container.msRequestFullscreen()
  //   }
  // }
  return !authStatus.authenticated ? (
    authStatus.reason === 'missing' ? (
      <Redirect to={'/login'} />
    ) : null
  ) : (
    <Layout>
      <Spin spinning={spinLoading} size="large" style={{ top: '50vh', transform: 'translateY(-50%)', zIndex: 10000 }}>
        <Header
          authenticated={true}
          // fullDom={
          //   <FullscreenOutlined
          //     onClick={handleFullScreen}
          //     style={{ fontSize: heightSize / 4 }}
          //     className="nike_full_screen"
          //   />
          // }
        ></Header>
        <Layout className="main-layout" style={{ height: `calc(100vh - ${defaultHeight * deviceSize}px)` }}>
          <Sider
            width={defaultSiderSize * deviceSize}
            className="menu-container shadow-box-right"
            style={{ height: `calc(100vh - ${defaultHeight * deviceSize}px)` }}
          >
            <Menu
              theme="dark"
              mode="inline"
              inlineIndent={15}
              openKeys={openKeys}
              onClick={menuClick}
              onOpenChange={onOpenChange}
              items={menusList}
              selectedKeys={[menuLoaction.pathname]}
            ></Menu>
          </Sider>
          <Layout
            className="main-container"
            id="main-container"
            ref={containerRef}
            style={{ marginLeft: defaultSiderSize * deviceSize }}
          >
            <Content className="content-layout">
              <div className="content-wrapper">
                <Switch>
                  <Route exact path="/" component={Welcome} />
                  {generateRoute(routerConfig)}
                  <Route exact path="*" render={Page404} />
                </Switch>
              </div>
            </Content>
          </Layout>
        </Layout>
      </Spin>
    </Layout>
  )
}

export default MainLayout
